
import { EnrichedAssignmentMetricsByWorkload } from '@/pages/OperationsInsights/types/AssignmentMetricsResponseEnriched';

/**
 * Transform data for High Chart Series - Open Assignments By Workload
 * @param metrics
 */
export const tfCsAssignmentOpenByWorkload = (metrics: EnrichedAssignmentMetricsByWorkload[]) => {

    const xAxisCategories: string[] = [];
    // for stacked bar, data label is enabled by default. So need to disable it
    const dataLabels = { enabled: false };
    const chartSeries = [
        {
            type: 'column' as const,
            name: 'Open Within SLA',
            color: '#2caffe', // light-blue
            dataLabels,
            data: [] as number[][]
        },
        {
            type: 'column' as const,
            name: 'Open At Risk',
            color: '#ff8503', // amber
            dataLabels,
            data: [] as number[][]
        },
        {
            type: 'column' as const,
            name: 'Open Breached',
            color: 'red',
            dataLabels,
            data: [] as number[][]
        }
    ];
    for (const metric of metrics) {
        xAxisCategories.push(metric.name);

        // Open Within SLA
        chartSeries[0].data.push([ xAxisCategories.length - 1, metric.openWithinSLAEoP ?? 0 ]);
        // Open At Risk
        chartSeries[1].data.push([ xAxisCategories.length - 1, metric.openAtRiskEoP ?? 0 ]);
        // Open Breached
        chartSeries[2].data.push([ xAxisCategories.length - 1, metric.openBreachedEoP ?? 0 ]);
    }
    return { xAxisCategories, chartSeries };
};